import { Sort } from '../interfaces/sort';

export class Unsorted<T> implements Sort<T> {
  constructor(public readonly items: T[]) {}

  sort(): T[] {
    return [...this.items];
  }
}
